exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1Lq1JPcLwrgUUndhwsOnCD+._1Lq1JPcLwrgUUndhwsOnCD{margin-top:1.78571rem}._15EbDZW_e7WIv6QKU_948N{-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}._2nfQ4DTwaIIk6nIRxtT2uP{float:right;font-size:1.14286rem;left:-.71429rem;position:relative;top:-2.14286rem}._2nfQ4DTwaIIk6nIRxtT2uP a{cursor:pointer}._3XK8Cs737lM6GaQYE9KKId{font-size:.85714rem;line-height:1rem;position:absolute;right:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
exports.locals = {
	"HomeworkContentItemForm": "_1Lq1JPcLwrgUUndhwsOnCD",
	"HomeworkContentItemForm_textarea": "_15EbDZW_e7WIv6QKU_948N",
	"HomeworkContentItemForm_deleteButton": "_2nfQ4DTwaIIk6nIRxtT2uP",
	"HomeworkContentItemForm_charactersUsed": "_3XK8Cs737lM6GaQYE9KKId"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/AssignHomework/Assignments/PersonalisedHomeworkFormCard/HomeworkContentItemForm/style.postcss
// module id = 1720
// module chunks = 0